import React, { createContext, useState, useContext, useEffect } from 'react';

// Criando o contexto de tema
const ThemeContext = createContext();

// Hook para usar o contexto de tema
export const useTheme = () => {
  return useContext(ThemeContext);
};

// Provedor do contexto de tema
export const ThemeProvider = ({ children }) => {
  // Verificar se há uma preferência salva no localStorage
  const savedTheme = localStorage.getItem('theme');
  const [darkMode, setDarkMode] = useState(savedTheme === 'dark');

  // Efeito para aplicar a classe ao body quando o tema mudar
  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark-mode');
      document.body.classList.remove('light-mode');
      localStorage.setItem('theme', 'dark');
    } else {
      document.body.classList.add('light-mode');
      document.body.classList.remove('dark-mode');
      localStorage.setItem('theme', 'light');
    }
  }, [darkMode]);

  // Função para alternar entre tema claro e escuro
  const toggleTheme = () => {
    setDarkMode(prevMode => !prevMode);
  };

  // Valor do contexto
  const value = {
    darkMode,
    toggleTheme
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext; 